const NONE_EN = 'NONE';
const NONE_HE = 'אין';

const isNoneValue = (value: string) => {
    const lowercaseValue = value?.toLowerCase();
    const noneLowercaseEn = NONE_EN.toLowerCase();

    return (lowercaseValue === noneLowercaseEn) || (lowercaseValue === NONE_HE);
}

export default isNoneValue